import { ChangeDetectorRef, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Course } from 'src/app/administration/course/course';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';

@Component({
    selector: 'add-course-modal',
    templateUrl: './add-course-modal.component.html',
    styleUrl: './add-course-modal.component.scss',
    standalone: false
})
export class AddCourseModalComponent extends BaseModalComponent{
  public course: Course;
  public error: string;
  public showError: boolean = false;

  constructor(public diaglogRef: MatDialogRef<AddCourseModalComponent>,
    private cdRef: ChangeDetectorRef
  ){
    super();
  }

  getEstablishment(event){
    this.error = '';
    this.showError = false;

    if(event.name.toLowerCase().includes('club') || event.name.toLowerCase().includes('golf')){
      let data = {
        id: '',
        name: event.name,
        shortName: event.name.split('Golf')[0].trim(),
        address: this.buildAddress(event.address_components),
        city: this.cityFromAddressComponents(event.address_components),
        state: event.address_components.find(component => component.types.includes('administrative_area_level_1')).short_name,
        country: event.address_components.find(component => component.types.includes('country')).short_name,
        zipCode: event.address_components.find(component => component.types.includes('postal_code')).short_name,
        isPrivate: false
      }

      this.course = data;
    }else{
      this.error = `The address you provided seems to be a place of business that is not associated to a Golf Course.<br /><br /> 
      If you feel this is a mistake, please contact our support center at support@golftechmgt.com`;
      this.showError = true;
    }

    this.cdRef.detectChanges();
  }

  /** Prefer `locality` (city); fall back to `administrative_area_level_3` when Google omits locality. */
  private cityFromAddressComponents(address_components: { types: string[]; short_name: string }[]): string {
    const locality = address_components.find((c) => c.types.includes('locality'));
    if (locality) {
      return locality.short_name;
    }
    const adminLevel3 = address_components.find((c) => c.types.includes('administrative_area_level_3'));
    return adminLevel3?.short_name ?? '';
  }

  private buildAddress(address_components): string{
    if(address_components.find(component => component.types.includes('street_number'))?.long_name !== undefined){
       return `${address_components.find(component => component.types.includes('street_number')).long_name} ${address_components.find(component => component.types.includes('route')).short_name}`
    }else{
      return address_components.find(component => component.types.includes('route')).short_name
    }
  }

  onSave(){
    this.diaglogRef.close(this.course);
  }
}
